import React from 'react';
import useTilt from '../hooks/useTilt';

function ProjectItem({ img_src, title, tags, description, github_link }) {
  const tilt = useTilt({ max: 5, scale: 1.01 });

  return (
    <article
      className="project-card"
      ref={tilt.ref}
      onMouseMove={tilt.onMouseMove}
      onMouseLeave={tilt.onMouseLeave}
    >
      <div className="project-card__image-wrap">
        <img className="project-card__image" src={img_src} alt={title} />
        <div className="project-card__image-overlay" />
      </div>
      <div className="project-card__body">
        <div className="project-card__tags">
          {tags.split('/').map((tag) => (
            <span key={tag.trim()} className="project-card__tag">
              {tag.trim()}
            </span>
          ))}
        </div>
        <h3 className="project-card__title">{title}</h3>
        <p className="project-card__desc">{description}</p>
        <a
          href={github_link}
          target="_blank"
          rel="noreferrer"
          className="project-card__link"
        >
          <i className="fa-brands fa-github" />
          <span>View Source</span>
          <i className="fa-solid fa-arrow-up-right-from-square project-card__link-arrow" />
        </a>
      </div>
    </article>
  );
}

export default ProjectItem;
